import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const { t } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: t('nav.home'), href: '/' },
    { label: t('nav.category'), href: '/category/hot' },
    { label: t('nav.about'), href: '/about' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 w-full ${
        isScrolled ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-play-circle-fill text-3xl text-primary-500"></i>
            </div>
            <span className="text-xl font-heading text-foreground-900 group-hover:text-primary-500 transition-colors whitespace-nowrap">
              黄瓜视频
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-8" aria-label="主导航">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === link.href
                    ? 'text-primary-500'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder={t('nav.search')}
                className="w-48 px-4 py-2 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
              />
              <i className="ri-search-line absolute right-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
            <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">{t('nav.login')}</a>
            <Link
              to="/about"
              className="px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('nav.register')}
            </Link>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl text-foreground-800 ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 animate-fade-in">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium py-2 whitespace-nowrap ${
                  location.pathname === link.href ? 'text-primary-500' : 'text-foreground-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="relative mt-2">
              <input
                type="text"
                placeholder={t('nav.search')}
                className="w-full px-4 py-2.5 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-300"
              />
              <i className="ri-search-line absolute right-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
            <div className="flex gap-3 mt-2">
              <a href="#" className="flex-1 text-center py-2.5 rounded-full border border-background-200 text-sm text-foreground-700 hover:bg-background-100 transition-colors whitespace-nowrap">{t('nav.login')}</a>
              <Link to="/about" className="flex-1 text-center py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap">{t('nav.register')}</Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}